export default "__VITE_ASSET__C47h69Wu__"